import axios from 'axios';
import { getBackendUrl } from '../utils/utils';
const apiClient = axios.create();
export default apiClient;
export const initializeApiClient = (isProd, localBackendUrl) => {
    const backendUrl = getBackendUrl(isProd, localBackendUrl);
    apiClient.defaults.baseURL = `${backendUrl}`;
};
